import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Suspense as _Suspense, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { class: "app-layout" }
const _hoisted_2 = { class: "app-layout__content" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify--end"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_5 = { class: "app-layout__page" }
const _hoisted_6 = { class: "layout fluid gutter--md" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Loading... ")

import { computed, inject, onBeforeUnmount, onMounted, ref } from "vue";
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import { SidebarDescriptor } from "@/notifi_types";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { useAppStore } from "@/store/pinia_app";


export default /*#__PURE__*/_defineComponent({
  props: {
  protocolID: { type: String, required: false },
  subscriptionID: { type: String, required: false },
  typeName: { type: String, required: false },
},
  setup(__props) {

const props = __props

const router = useRouter();
const appStore = useAppStore();
const moralis: any = inject("Moralis");
const userIsManager = computed((): boolean => {
  const u = moralis.User.current();
  return u && u.get("ProtocolManager");
});

// eslint-disable-next-line no-undef


const items = ref<SidebarDescriptor[]>([
  { title: "Protocols", icon: "announcement", to: "/protocols" },
  { title: "Positions", icon: "radar", to: "/positions" },
  { title: "Groups", icon: "bookmarks", to: "/groups" },
  { title: "Subscriptions", icon: "dashboard", to: "/subscriptions" },
  { title: "Subscribe", icon: "loop", to: "/subscription" },
  { title: "My Account", icon: "manage_accounts", to: "/my_account" },
  { title: "My Channels", icon: "import_contacts", to: "/my_channels" },
]);

const route = useRoute();
const activeRouteName = ref(route.path);

const isRouteActive = (item: SidebarDescriptor) => {
  return activeRouteName.value === item.to;
};
const setRouteActive = (item: SidebarDescriptor) => {
  activeRouteName.value = item.to;
};

if (userIsManager.value) {
  const manager: SidebarDescriptor = {
    title: "Manager",
    icon: "admin_panel_settings",
    to: "/manager/select",
    text_color: "warning",
  };
  items.value.push(manager);
}

const managerItems = computed(() => {
  const mItems: SidebarDescriptor[] = [];
  if (props.protocolID != undefined && userIsManager.value) {
    mItems.push(
      ...[
        {
          title: "Send",
          icon: "notifications",
          to: `/manager/${props.protocolID}/send`,
          text_color: "warning",
        },
        {
          title: "Settings",
          icon: "settings",
          to: `/manager/${props.protocolID}/settings`,
          text_color: "warning",
        },
        {
          title: "Subscription",
          icon: "point_of_sale",
          to: `/manager/${props.protocolID}/subscription`,
          text_color: "warning",
        },
        {
          title: "Categories",
          icon: "tune",
          to: `/manager/${props.protocolID}/categories`,
          text_color: "warning",
        },
        {
          title: "History",
          icon: "view_list",
          to: `/manager/${props.protocolID}/history`,
          text_color: "warning",
        },
        {
          title: "Contracts",
          icon: "alt_route",
          to: `/manager/${props.protocolID}/contracts`,
          text_color: "warning",
        },
      ]
    );
  }
  return mItems;
});

const mobileBreakPointPX = 640;
const tabletBreakPointPX = 768;

const sidebarWidth = ref("14rem");
const sidebarMinimizedWidth = ref<undefined | string | number>(undefined);

const isMobile = ref(false);
const isTablet = ref(false);
const isSidebarMinimized = computed(() => appStore.isSidebarMinimized);
const checkIsTablet = () => window.innerWidth <= tabletBreakPointPX;
const checkIsMobile = () => window.innerWidth <= mobileBreakPointPX;

const onResize = () => {
  appStore.isSidebarMinimized = checkIsTablet();

  isMobile.value = checkIsMobile();
  isTablet.value = checkIsTablet();
  sidebarMinimizedWidth.value = isMobile.value ? 0 : "4rem";
  sidebarWidth.value = isTablet.value ? "100%" : "16rem";
};

onMounted(() => {
  window.addEventListener("resize", onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});

onBeforeRouteUpdate(() => {
  if (checkIsTablet()) {
    // Collapse sidebar after route change for Mobile
    appStore.isSidebarMinimized = true;
  }
});

onResize();

const isFullScreenSidebar = computed(
  () => isTablet.value && !isSidebarMinimized.value
);

const onCloseSidebarButtonClick = () => {
  appStore.isSidebarMinimized = true;
};

const minimized = computed({
  get: () => appStore.isSidebarMinimized,
  set: (value) => (appStore.isSidebarMinimized = value),
});

const logout = async () => {
  moralis.User.logOut();
  router.push({ name: "Login" });
};

moralis.onAccountChanged(async (account: string) => {
  const confirmed = confirm("Link this address to your account?");
  if (confirmed) {
    await moralis.link(account);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_sidebar_item_title = _resolveComponent("va-sidebar-item-title")!
  const _component_va_sidebar_item_content = _resolveComponent("va-sidebar-item-content")!
  const _component_va_sidebar_item = _resolveComponent("va-sidebar-item")!
  const _component_va_sidebar = _resolveComponent("va-sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["app-layout__sidebar-wrapper", { minimized: _unref(isSidebarMinimized) }])
        }, [
          (_unref(isFullScreenSidebar))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_va_button, {
                  class: "px-4 py-4",
                  icon: "close",
                  flat: "",
                  color: "dark",
                  onClick: onCloseSidebarButtonClick
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_va_sidebar, {
            minimized: _unref(minimized),
            textColor: "dark",
            width: sidebarWidth.value,
            minimizedWidth: sidebarMinimizedWidth.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createBlock(_component_va_sidebar_item, {
                  key: item.to,
                  active: isRouteActive(item),
                  onClick: ($event: any) => (setRouteActive(item)),
                  to: item.to,
                  "text-color": item.text_color
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_sidebar_item_content, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_icon, {
                          name: item.icon
                        }, null, 8, ["name"]),
                        (!_unref(minimized))
                          ? (_openBlock(), _createBlock(_component_va_sidebar_item_title, {
                              key: 0,
                              style: {"height":"24px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.title), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["active", "onClick", "to", "text-color"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(managerItems), (item) => {
                return (_openBlock(), _createBlock(_component_va_sidebar_item, {
                  key: item.to,
                  active: isRouteActive(item),
                  onClick: ($event: any) => (setRouteActive(item)),
                  to: item.to,
                  "text-color": item.text_color
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_sidebar_item_content, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, "  ", 512), [
                          [_vShow, !_unref(minimized)]
                        ]),
                        _createVNode(_component_va_icon, {
                          name: item.icon
                        }, null, 8, ["name"]),
                        (!_unref(minimized))
                          ? (_openBlock(), _createBlock(_component_va_sidebar_item_title, {
                              key: 0,
                              style: {"height":"24px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.title), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["active", "onClick", "to", "text-color"]))
              }), 128)),
              _createVNode(_component_va_sidebar_item, {
                to: "#",
                onClick: _withModifiers(logout, ["prevent"]),
                "text-color": "danger"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_sidebar_item_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_icon, {
                        name: "logout",
                        color: "danger"
                      }),
                      _withDirectives(_createVNode(_component_va_sidebar_item_title, {
                        "text-color": "danger",
                        style: {"height":"24px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, !_unref(minimized)]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["minimized", "width", "minimizedWidth"])
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_openBlock(), _createBlock(_Suspense, {
                    key: _ctx.$route.fullPath
                  }, {
                    fallback: _withCtx(() => [
                      _hoisted_7
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                        key: _ctx.$route.fullPath
                      }))
                    ]),
                    _: 2
                  }, 1024))
                ], 1024))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})